import createObserver from 'utils/observers/createObserver';

const MODAL_ACTIVE_CLASS = 'body_modal-active';

let observer;


class BodyScroll {
  static disable (option = {}) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.marginRight = `${scrollbarWidth}px`;
    document.body.classList.add(MODAL_ACTIVE_CLASS);

    if (option.infinity && !observer) {
      observer = createObserver(
        'MutationObserver',
        document.body,
        (mutationsList) => {
          mutationsList.forEach(mutation => {
            if (mutation.attributeName === 'class' && !mutation.target.className.includes(MODAL_ACTIVE_CLASS)) {
              this.disable();
            }
          });
        },
        {attributes: true}
      );
    }
  }

  static enable (option = {}) {
    if (option?.infinity === false && observer) {
      observer.observerDestructor();
      observer = null;
    }

    document.documentElement.style.marginRight = '';
    document.body.classList.remove(MODAL_ACTIVE_CLASS);
  }
}

export default BodyScroll;
